import LoadingComponent from "components/Loading/LoadingComponent"
import React from "react"
import Skeleton from "react-loading-skeleton"
import ScrollBar from "react-perfect-scrollbar"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import InspectionAction from "store/inspection-resource/actions"
import { inspectionCheck } from "../../inspectionCheck"
import ModalRemarks from "./ModalRemarks"

function InspectionChecklist({ validation, selectedInspection }) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const [isOpen, setIsOpen] = React.useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const detailRtwOrder = store.inspection.detailRtwOrder.data

  if (store.inspection.detailRtwOrder.loading) {
    return <LoadingComponent />
  }

  return (
    <>
      <ModalRemarks
        isOpen={isOpen}
        toggle={toggle}
        validation={validation}
        selectedInspection={selectedInspection}
      />
      <Card>
        <CardBody>
          <ScrollBar style={{ height: 620 }}>
            <Row>
              <Col>
                {detailRtwOrder.orderNumber}/{detailRtwOrder.companyName}/
                {detailRtwOrder.size} - {detailRtwOrder.sequence}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="4">製作者</Col>
              <Col md="8">{detailRtwOrder.producers.join(", ")}</Col>
            </Row>
            <Row className="mt-3">
              <Col md="4">ステータス</Col>
              <Col md="4">{detailRtwOrder.status}</Col>
              <Col md="4">
                <Button color="warning" onClick={toggle}>
                  備考
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <table className="table table-bordered table-striped tabel-hover">
                <thead>
                  <tr>
                    <td>検品項目</td>
                    <td>製作者</td>
                    <td>検品者</td>
                  </tr>
                </thead>
                <tbody>
                  {inspectionCheck.map((i, k) => (
                    <tr key={k}>
                      <td>{i.title}</td>
                      <td>
                        <Input
                          type="checkbox"
                          disabled={!detailRtwOrder.producerEditable}
                          value={
                            detailRtwOrder.producerEditable
                              ? validation.values[i.name]
                              : detailRtwOrder.producer[i.name]
                          }
                          checked={
                            detailRtwOrder.producerEditable
                              ? validation.values[i.name]
                              : detailRtwOrder.producer[i.name]
                          }
                          onClick={e => {
                            validation.setFieldValue(
                              i.name,
                              !validation.values[i.name]
                            )
                          }}
                          onChange={e => {}}
                          style={{
                            height: "18px",
                            width: "18px",
                          }}
                        />
                      </td>
                      <td>
                        <Input
                          type="checkbox"
                          disabled={!detailRtwOrder.inspectorEditable}
                          value={
                            detailRtwOrder.inspectorEditable
                              ? validation.values[i.name]
                              : detailRtwOrder.inspector[i.name]
                          }
                          checked={
                            detailRtwOrder.inspectorEditable
                              ? validation.values[i.name]
                              : detailRtwOrder.inspector[i.name]
                          }
                          onClick={e => {
                            validation.setFieldValue(
                              i.name,
                              !validation.values[i.name]
                            )
                          }}
                          onChange={e => {}}
                          style={{
                            height: "18px",
                            width: "18px",
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
            <div className="text-center">
              <Input
                type="checkbox"
                checked={validation.values.defect}
                onChange={() => {
                  dispatch(InspectionAction.patchDefect(selectedInspection))
                }}
                style={{
                  height: "18px",
                  width: "18px",
                }}
              />
              <Label className="ms-2">不良品</Label>
            </div>

            <div className="d-flex justify-content-center">
              {store.inspection.postRtwOrder.loading ? (
                <Skeleton height={30} width={50} />
              ) : (
                <Button type="submit" color="primary">
                  保存
                </Button>
              )}
            </div>
          </ScrollBar>
        </CardBody>
      </Card>
    </>
  )
}

export default InspectionChecklist
